export default __webpack_public_path__ + "static/media/logo.e14d5677.gif";